import React from 'react';

const InCompleteIcon = () => {
    return (
        <img
            title="refresh"
            src={`${process.env.PUBLIC_URL}/assets/icons/not-done.svg`}
            alt="refresh"
            style={{ width: '2em', height: '2em'}}
        />
    );
};

export default InCompleteIcon;
